// ../../atoms/Mention/MentionChipsBar.tsx
import React from 'react';
import './MentionChipsBar.scss';
export type MentionChip = {
  email: string;
  display: string;
  userId?: string;
  imageId?: string;
};

type MentionChipsBarProps = {
  mentions: MentionChip[];
  onRemove: (idOrEmail: string) => void;
  className?: string;
  style?: React.CSSProperties;
};

const MentionChipsBar: React.FC<MentionChipsBarProps> = ({
  mentions,
  onRemove,
  className,
  style,
}) => {
  // Clean up display text by removing invisible characters and leading @ symbols
  const cleanDisplay = (text: string) => text
    .replace(/[\u200B-\u200D\uFEFF]/g, '') // Remove zero-width and BOM characters
    .replace(/^@+/, '') // Remove leading @ symbols
    .trim(); // Remove whitespace

  return (
    <div
      className={['mention-chipbar', className].filter(Boolean).join(' ')}
      style={style}
    >
      <i className="pi pi-user-plus chipbar-icon" />
      <span className="chipbar-label">
        Add mentions
      </span>

      {mentions.map((m) => {
        const displayText = cleanDisplay(m.display || m.email);
        return (
          <span
            key={m.userId || m.email}
            className="mention-chip"
          >
            <span
              className="mention-chip-avatar"
            >
              {displayText[0]?.toUpperCase()}
            </span>
            <span className="mention-chip-text">+ {displayText}</span>
            <button
              type="button"
              className="mention-chip-remove"
              onClick={() => onRemove(m.userId || m.email)}
              aria-label={`Remove mention for ${displayText}`}
              title={`Remove mention for ${displayText}`}
            >
              ×
            </button>
          </span>
        );
      })}
    </div>
  );
};

export default MentionChipsBar;
